<template>
  <!-- 上门服务-服务售后管理 -->
  <basic-container>
    <el-form
      :model="searchForm"
      ref="searchFormRef"
      label-width="100px"
      label-suffix=":"
      v-show="searchBoxFlag"
    >
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="项目名称" prop="projectId">
            <el-select v-model="searchForm.projectId" style="width: 100%" placeholder="项目名称">
              <el-option
                v-for="item in projectIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="售后单号" prop="code">
            <el-input
              clearable
              v-model="searchForm.code"
              style="width: 100%"
              placeholder="售后单号"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="服务单号" prop="orderCode">
            <el-input
              clearable
              v-model="searchForm.orderCode"
              style="width: 100%"
              placeholder="服务单号"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="用户" prop="applyUserName">
            <el-input
              clearable
              v-model="searchForm.applyUserName"
              placeholder="用户"
              maxlength="100"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="9">
          <el-form-item label="售后申请时间" prop="applydaterange">
            <el-date-picker
              v-model="searchForm.applydaterange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="9">
          <el-form-item label="售后处理时间" prop="handledaterange">
            <el-date-picker
              v-model="searchForm.handledaterange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="售后状态" prop="afterSalesStatus">
            <el-select
              v-model="searchForm.afterSalesStatus"
              style="width: 100%"
              placeholder="售后状态"
            >
              <el-option
                v-for="item in afterSalesStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <div style="float: right">
            <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
              搜索
            </el-button>
            <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>

    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      ref="crud"
      @on-load="getData"
      :before-open="beforeOpen"
      @search-change="searchChange"
      @search-reset="searchReset"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="getData"
      @selection-change="selectionChange"
    >
      <template slot="menuRight">
        <searchFromShow
          :searchBoxFlag.sync="searchBoxFlag"
          :removeHeight="searchHeight"
          :option="option"
          reduceHeight="20"
          :refOption="$refs.crud"
        ></searchFromShow>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-edit-outline"
          v-if="permissionList.afterSaleHandleBtn && scope.row.afterSalesStatus == 0"
          @click="handle(scope.row)"
          >处理
        </el-button>

        <el-button
          type="text"
          size="small"
          icon="el-icon-view"
          v-if="permissionList.afterSaleDetailBtn"
          @click="details(scope.row)"
          >详情
        </el-button>
      </template>
      <!-- 售后详情 -->
      <template slot="code" slot-scope="scope">
        <el-link
          type="primary"
          :underline="false"
          style="vertical-align: middle;line-height: normal;"
          @click="openAfterSaleDialog(scope.row)"
          >{{ scope.row.code }}</el-link
        >
      </template>
      <!-- 工单详情 -->
      <template slot="orderCode" slot-scope="scope">
        <el-link
          type="primary"
          :underline="false"
          style="vertical-align: middle;line-height: normal;"
          @click="showOrderDetail(scope.row.outOrderId)"
          >{{ scope.row.orderCode }}
        </el-link>
      </template>
    </avue-crud>

    <hr-dialog
      title="申请单详情"
      :allowFull="false"
      width="60%"
      :visible.sync="afterSaleApplyDetailVisible"
    >
      <template slot="body">
        <afterSaleDetails
          :row="formRow"
          @cancle="recordCancle"
          @success="recordSuccess"
          v-if="afterSaleApplyDetailVisible"
        >
        </afterSaleDetails>
      </template>
    </hr-dialog>
    <!-- 工单详情弹框 -->
    <orderDetail ref="orderDetailRef" v-if="isNeedOrderDetailShow" :orderId="orderId">
    </orderDetail>

    <hr-dialog
      title="售后处理"
      :allowFull="false"
      width="60%"
      :visible.sync="afterSaleTreatmentVisible"
    >
      <template slot="body">
        <afterSaleTreatment
          :row="formRow"
          @cancle="recordCancle"
          @success="recordSuccess"
          v-if="afterSaleTreatmentVisible"
        >
        </afterSaleTreatment>
      </template>
    </hr-dialog>

    <hr-dialog
      title="售后详情"
      :allowFull="false"
      width="60%"
      :visible.sync="afterSaleDetailsVisible"
    >
      <template slot="body">
        <afterSaleDetails
          :row="formRow"
          @cancle="recordCancle"
          @success="recordSuccess"
          v-if="afterSaleDetailsVisible"
        >
        </afterSaleDetails>
      </template>
    </hr-dialog>
  </basic-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { getProjectList } from '@/api/crmedical/project/project';
import afterSaleDetails from './afterSaleDetails.vue';
import afterSaleTreatment from './afterSaleTreatment.vue';
import orderDetail from './orderDetail.vue';
import searchFromShow from '@/components/search-form-show/index';
import { getList, getDetail } from '@/api/v4ward/out/order/after/sales/outorderaftersales.js';
export default {
  components: {
    searchFromShow,
    afterSaleDetails,
    afterSaleTreatment,
    orderDetail,
  },
  data() {
    return {
      isNeedOrderDetailShow: false, //是否需要显示工单详情
      orderId: '', // 工单id
      afterSaleTreatmentVisible: false,
      afterSaleDetailsVisible: false,
      afterSaleApplyDetailVisible: false,
      afterServiceDetailVisible: false,
      projectIdList: [],
      searchHeight: '',
      searchBoxFlag: true,
      afterSalesStatusList: [
        {
          label: '待处理',
          value: 0,
        },
        {
          label: '售后完成',
          value: 1,
        },
        {
          label: '售后关闭',
          value: 2,
        },
      ],
      searchForm: {
        projectId: '',
        code: '',
        orderCode: '',
        applyUserName: '',
        afterSalesStatus: 0,
        upWarnFlag: 'false',
        downWarnFlag: 'false',
      },
      formRow: {},
      selectionList: [],
      option: {
        selection: false,
        select: true,
        index: true,
        indexLabel: '序号',
        align: 'left',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '项目名称',
            prop: 'projectId',
            hide: true,
            rules: [
              {
                required: true,
                message: '请选择项目名称',
                trigger: 'change',
              },
            ],
            type: 'select',
            dicUrl: '',
            props: {
              label: 'name',
              value: 'id',
            },
          },
          {
            label: '售后单号',
            prop: 'code',
            width: 180,
            slot: true,
          },
          {
            label: '申请原因',
            prop: 'applyReason',
            overHidden: true,
          },
          {
            label: '售后申请时间',
            width: 150,
            prop: 'createTime',
          },
          {
            label: '售后状态',
            prop: 'afterSalesStatus',
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=out_order_after_sales_status',
            props: { label: 'dictValue', value: 'dictKey' },
            rules: [
              {
                required: true,
                message: '请输入售后状态',
                trigger: 'change',
              },
            ],
          },
          {
            label: '售后处理时间',
            prop: 'handleTime',
            width: 150,
          },
          {
            label: '服务订单号',
            prop: 'orderCode',
            width: 180,
            slot: true,
          },
          {
            label: '服务项目',
            prop: 'serviceItemName',
          },
          {
            label: '用户',
            prop: 'applyUserName',
          },
          {
            label: '服务商',
            prop: 'providerName',
            width: 180,
          },
          {
            label: '服务人员',
            prop: 'handerName',
          },
        ],
      },
      loading: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
    };
  },
  created() {
    this.initData();
  },
  mounted() {
    this.ajustView();
    this.calcHeight();
    let self = this;
    self.$refs.crud && self.$refs.crud.doLayout();
    window.onresize = () => {
      self.$refs.crud.doLayout();
    };
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
    this.$refs.crud.doLayout();
  },
  computed: {
    //按钮权限控制
    ...mapGetters(['permission']),
    permissionList() {
      return {
        afterSaleHandleBtn: this.vaildData(this.permission.afterSaleHandleBtn, false),
        afterSaleDetailBtn: this.vaildData(this.permission.afterSaleDetailBtn, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    // 调整表格高度
    calcHeight() {
      this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
      this.option.height = this.bodyHeight - this.searchHeight - 279 - 10;
    },
    /* 显示工单详情 */
    showOrderDetail(orderId) {
      this.orderId = orderId;
      if (this.isNeedOrderDetailShow) {
        this.$refs.orderDetailRef.show();
      } else {
        this.isNeedOrderDetailShow = true;
        this.$nextTick(() => {
          this.$refs.orderDetailRef.show();
        });
      }
    },
    openAfterSaleDialog(row) {
      this.formRow = row;
      this.afterSaleApplyDetailVisible = true;
    },
    openServiceDialog(row) {
      this.formRow = row;
      this.afterServiceDetailVisible = true;
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    initData() {
      getProjectList().then((res) => {
        this.projectIdList = res.data;
        this.searchForm.projectId = res.data[0].id;
        this.getData();
      });
    },
    getData(page) {
      if (!this.searchForm.projectId) {
        return;
      }
      page = page || this.page;
      this.loading = true;
      getList(
        Object.assign({}, { current: page.currentPage, size: page.pageSize }, this.searchForm)
      ).then(({ data }) => {
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
      });
    },

    //处理弹窗
    handle(row) {
      this.formRow = row;
      this.afterSaleTreatmentVisible = true;
    },
    //详情弹窗
    details(row) {
      this.formRow = row;
      this.afterSaleDetailsVisible = true;
      // getDetail({ id: row.id }).then(({ data }) => {
      //   this.form = data;
      // });
    },
    ajustView() {
      const tableInitH = this.bodyHeight - 445; // 表格区域初始化高度
      const searchH = 110; // 搜索区域占的高度
      this.option.height = tableInitH;

      this.$nextTick(() => {
        setTimeout(() => {
          let children = this.$refs.crud.$children[1].$children;
          children[children.length - 2].$el.addEventListener('click', () => {
            if (this.option.height == tableInitH) {
              this.option.height = tableInitH + searchH;
            } else {
              this.option.height = tableInitH;
            }
            this.$refs.crud.getTableHeight();
          });
        });
      });

      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    //搜索
    searchRecord() {
      this.page.currentPage = 1;
      if (this.searchForm.applydaterange && this.searchForm.applydaterange.length > 0) {
        this.searchForm.applyTimeStart = this.dayjs(this.searchForm.applydaterange[0]).format(
          'YYYY-MM-DD 00:00:00'
        );
        this.searchForm.applyTimeEnd = this.dayjs(this.searchForm.applydaterange[1]).format(
          'YYYY-MM-DD 23:59:59'
        );
      } else {
        this.searchForm.applyTimeStart = '';
        this.searchForm.applyTimeEnd = '';
      }
      if (this.searchForm.handledaterange && this.searchForm.handledaterange.length > 0) {
        this.searchForm.handleTimeStart = this.dayjs(this.searchForm.handledaterange[0]).format(
          'YYYY-MM-DD 00:00:00'
        );
        this.searchForm.handleTimeEnd = this.dayjs(this.searchForm.handledaterange[1]).format(
          'YYYY-MM-DD 23:59:59'
        );
      } else {
        this.searchForm.handleTimeStart = '';
        this.searchForm.handleTimeEnd = '';
      }
      this.getData();
    },
    //清空
    searchClear() {
      this.tool.clearObject(this.searchForm, 'projectId');
      this.searchForm.type = '';
    },
    //取消
    recordCancle() {
      this.afterSaleTreatmentVisible = false;
      this.afterSaleDetailsVisible = false;
    },
    //确定
    recordSuccess() {
      this.afterSaleTreatmentVisible = false;
      this.afterSaleDetailsVisible = false;
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .avue-crud__right {
  display: flex;
}
/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}
</style>
